var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form-item', {
    attrs: {
      "label": _vm.i18nt('designer.setting.drawDirection')
    }
  }, [_c('el-radio-group', {
    staticClass: "radio-group-custom",
    model: {
      value: (_vm.optionModel.direction),
      callback: function($$v) {
        _vm.$set(_vm.optionModel, "direction", $$v)
      },
      expression: "optionModel.direction"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "rtl"
    }
  }, [_c('i', {
    staticClass: "el-icon-back"
  })]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "ltr"
    }
  }, [_c('i', {
    staticClass: "el-icon-right"
  })]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "ttb"
    }
  }, [_c('i', {
    staticClass: "el-icon-bottom"
  })]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "btt"
    }
  }, [_c('i', {
    staticClass: "el-icon-top"
  })])], 1)], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57185c21","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-designer/setting-panel/property-editor/container-vf-drawer/vf-drawer-direction-editor.vue
// module id = null
// module chunks = 